import React from 'react';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';
import { SINGULAR_SOCIAL_NETWORKS } from '../../constants/singularEventTypes';
import { trackContentShare } from '../../utils/singularUtils';
import './styles.scss';

function SocialSharingList({
  content = null,
  trackingEnabled = false,
  subscriberId = null,
}) {
  const currentUrl = window.location.href;

  const handleShare = (shareMethod) => {
    if (!trackingEnabled) return;
    trackContentShare(shareMethod, content, { subscriber_id: subscriberId });
  };

  return (
    <ul className="social_sharing">
      <li>
        <FacebookShareButton
          url={currentUrl}
          beforeOnClick={() => handleShare(SINGULAR_SOCIAL_NETWORKS.FACEBOOK)}
        >
          <i className="bi bi-facebook"></i>
          Facebook
        </FacebookShareButton>
      </li>
      <li>
        <TwitterShareButton
          url={currentUrl}
          beforeOnClick={() => handleShare(SINGULAR_SOCIAL_NETWORKS.TWITTER)}
        >
          <i className="bi bi-twitter-x"></i>X
        </TwitterShareButton>
      </li>
      <li>
        <WhatsappShareButton
          url={currentUrl}
          beforeOnClick={() => handleShare(SINGULAR_SOCIAL_NETWORKS.WHATSAPP)}
        >
          <i className="bi bi-whatsapp"></i>
          Whatsapp
        </WhatsappShareButton>
      </li>
    </ul>
  );
}

export default SocialSharingList;
